import { useState, useEffect } from 'react';
import {
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonList,
  IonItem,
  IonLabel,
  IonButton,
  IonAlert,
} from '@ionic/react';
import { getLeaderboard, clearLeaderboard, ScoreEntry } from '../services/StorageService';
import './Leaderboard.css';

const Leaderboard: React.FC = () => {
  const [scores, setScores] = useState<ScoreEntry[]>([]);
  const [showClear, setShowClear] = useState(false);

  useEffect(() => {
    getLeaderboard().then(setScores);
  }, []);

  const handleClear = async () => {
    await clearLeaderboard();
    setScores([]);
    setShowClear(false);
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/home" />
          </IonButtons>
          <IonTitle>Leaderboard</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={() => setShowClear(true)} color="danger">
              Clear
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className="leaderboard-content">
        {scores.length === 0 ? (
          <div className="empty-state">
            <p>No high scores yet!</p>
            <p>Play a game to set the first record.</p>
          </div>
        ) : (
          <IonList>
            {scores.map((entry, i) => (
              <IonItem key={i}>
                <IonLabel>
                  <h2>
                    <span className="rank">#{i + 1}</span> {entry.name}
                  </h2>
                  <p>
                    Score: {entry.score.toLocaleString()} &middot; Level {entry.level} &middot;{' '}
                    {new Date(entry.date).toLocaleDateString()}
                  </p>
                </IonLabel>
              </IonItem>
            ))}
          </IonList>
        )}
        <IonAlert
          isOpen={showClear}
          onDidDismiss={() => setShowClear(false)}
          header="Clear Scores"
          message="Are you sure you want to clear all high scores?"
          buttons={[
            { text: 'Cancel', role: 'cancel' },
            { text: 'Clear', handler: handleClear },
          ]}
        />
      </IonContent>
    </IonPage>
  );
};

export default Leaderboard;
